import { cancelOccurrenceEditorText } from 'owa-locstrings/lib/strings/canceloccurrenceeditortext.locstring.json';
import { cancelThisEventForwardEditorText } from 'owa-locstrings/lib/strings/cancelthiseventforwardeditortext.locstring.json';
import { cancelSeriesEditorText } from 'owa-locstrings/lib/strings/cancelserieseditortext.locstring.json';
import { cancelOccurrenceSingleAttendeeEditorText } from 'owa-locstrings/lib/strings/canceloccurrencesingleattendeeeditortext.locstring.json';
import { cancelThisEventForwardSingleAttendeeEditorText } from 'owa-locstrings/lib/strings/cancelthiseventforwardsingleattendeeeditortext.locstring.json';
import { cancelSeriesSingleAttendeeEditorText } from 'owa-locstrings/lib/strings/cancelseriessingleattendeeeditortext.locstring.json';
import { allEventsInSeries } from 'owa-locstrings/lib/strings/alleventsinseries.locstring.json';
import { thisAndAllFollowingEvents } from 'owa-locstrings/lib/strings/thisandallfollowingevents.locstring.json';
import { thisEvent } from 'owa-locstrings/lib/strings/thisevent.locstring.json';
import { cancelEditorText } from 'owa-locstrings/lib/strings/canceleditortext.locstring.json';
import { cancelSingleAttendeeEditorText } from 'owa-locstrings/lib/strings/cancelsingleattendeeeditortext.locstring.json';
import loc from 'owa-localize';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EventScope from 'owa-service/lib/contract/EventScope';

import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import * as CalendarItemCapabilities from 'owa-calendar-event-capabilities';

export default function getCancelMenuItems(
    item: CalendarEvent,
    onCancelClicked: (eventScope: EventScope, editorTitleText: string) => void
): IContextualMenuItem[] {
    const isSeriesInstance = CalendarItemCapabilities.isSeriesInstance(item);
    const isSeriesMaster = CalendarItemCapabilities.isSeriesMaster(item);
    const singularAttendee =
        (item.RequiredAttendees ? item.RequiredAttendees.length : 0) +
            (item.OptionalAttendees ? item.OptionalAttendees.length : 0) ==
        1;
    var menuItems = isSeriesInstance
        ? [
              {
                  key: 'cancel_occurrence_edit',
                  name: loc(thisEvent),
                  onClick: () =>
                      onCancelClicked(
                          EventScope.ThisInstanceOnly,
                          loc(
                              singularAttendee
                                  ? cancelOccurrenceSingleAttendeeEditorText
                                  : cancelOccurrenceEditorText
                          )
                      ),
              },
              ...(CalendarItemCapabilities.canActFromThisDateForward(item)
                  ? [
                        {
                            key: 'cancel_thisandfollowing_edit',
                            name: loc(thisAndAllFollowingEvents),
                            onClick: () =>
                                onCancelClicked(
                                    EventScope.ThisAndFollowingInstances,
                                    loc(
                                        singularAttendee
                                            ? cancelThisEventForwardSingleAttendeeEditorText
                                            : cancelThisEventForwardEditorText
                                    )
                                ),
                        },
                    ]
                  : []),
              {
                  key: 'cancel_series_edit',
                  name: loc(allEventsInSeries),
                  onClick: () =>
                      onCancelClicked(
                          EventScope.AllInstancesInSeries,
                          loc(
                              singularAttendee
                                  ? cancelSeriesSingleAttendeeEditorText
                                  : cancelSeriesEditorText
                          )
                      ),
              },
          ]
        : [
              isSeriesMaster
                  ? {
                        key: 'cancel_series_edit',
                        name: loc(allEventsInSeries),
                        onClick: () =>
                            onCancelClicked(
                                EventScope.Default,
                                loc(
                                    singularAttendee
                                        ? cancelSeriesSingleAttendeeEditorText
                                        : cancelSeriesEditorText
                                )
                            ),
                    }
                  : {
                        key: 'cancel_occurrence_edit',
                        name: loc(thisEvent),
                        onClick: () =>
                            onCancelClicked(
                                EventScope.ThisInstanceOnly,
                                loc(
                                    singularAttendee
                                        ? cancelSingleAttendeeEditorText
                                        : cancelEditorText
                                )
                            ),
                    },
          ];

    return menuItems;
}
